import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { EVENT_NAME } from 'appenv';
import Routes from 'Routes';
import { useDispatch } from 'react-redux';
import { fetchExhibitors } from 'models/exhibitors';
import { fetchWebinars } from 'models/webinars';
import { fetchEvent } from 'models/event';

import AuthRoute from './AuthRoute';
import MainLobbyContainer from '../pages/main_lobby/MainLobbyContainer';
import BoothProfileRootContainer from '../pages/booths';
import HallPage from '../pages/hall/HallPage';
import WebinarPageContainer from '../pages/webinar/WebinarPageContainer';
import SearchResultContainer from '../pages/search/SearchResultContainer';
import LandingTemplateSwitch from '../pages/landing/LandingTemplateSwitch';
import PageNoFound from '../pages/PageNoFound';

const AppRouter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchEvent()).then(({ payload: eventPayload }) => {
      dispatch(fetchExhibitors());
      dispatch(fetchWebinars(eventPayload[0]));
    });
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{EVENT_NAME}</title>
        <meta name="description" content={EVENT_NAME} />
      </Helmet>
      <Switch>
        <AuthRoute
          exact
          path={[Routes.root, Routes.lobby]}
          route="lobby"
          component={MainLobbyContainer}
        />
        <AuthRoute
          path={Routes.booth()}
          route="booth"
          component={BoothProfileRootContainer}
        />
        <AuthRoute
          exact
          path={Routes.hall}
          route="hall"
          component={HallPage}
        />
        <AuthRoute
          exact
          path={Routes.webinar}
          route="webinar"
          component={WebinarPageContainer}
        />
        <AuthRoute
          exact
          path={Routes.search}
          route="search"
          component={SearchResultContainer}
        />
        <AuthRoute
          exact
          path={Routes.landing}
          route="landing"
          component={LandingTemplateSwitch}
        />
        <Route component={PageNoFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRouter;
